<template>
    <div :class="['fs5-input-copy',styleType == 'link-affiliate' ? 'w100' : '']">
        <div :class="['box-input-copy',styleType == 'link-affiliate' ? 'style-link-affiliate' : '']">
            <input type="text" :placeholder="view[0]" :id="'generated_content'+view[1]" v-model="view[1]" @click="copyItem()" readonly>
            <button class="btn-copy" type="button" @click="copyItem()">
                <img v-if="!showCopySuccessIcon" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content.svg">
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                </svg>
            </button>
            <builderall-icon v-if="tooltip !== '' && !!tooltip"
              code='help'
              :ba-tooltip-position="tooltipPosition"
              ba-tooltip-color='dark'
              :ba-tooltip-title="tooltip"
              :class="tooltipPosition == 'right' ? 'tooltip-fix' : ''"
            ></builderall-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-input-copy',
        // view[0] -> placeholder
        // view[1] -> value input
        // view[2] -> message success copy
        props: {
            view:{
                type: Array,
                required: true
            },
            styleType:{
                type: String,
                required: false,
                default: '',
            },
            tooltip: {
              type: String,
              required: false,
              default: ''
            },
            tooltipPosition: {
              type: String,
              required: false,
              default: 'bottom'
            }
        },
        data() {
            return {
                inputContent: '',
                showCopySuccessIcon: false,
            }
        },

        methods: {
            copyItem(){
                document.getElementById('generated_content'+this.view[1]).select();
                document.execCommand('copy');
                alertMsg("success", this.view[2]);
                this.showCopySuccessIcon = true;
                setTimeout(() => {this.showCopySuccessIcon = false}, 2000);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .w100{
        width: 100%;
    }
    .style-link-affiliate{
        background-color: transparent !important;
        border-radius: 0 !important;
        border: none !important;
        border-bottom: 1px solid $fs5-color5 !important;
    }
    .box-input-copy{
        width: 100%;
        height: 2.1em;
        text-align: center;
        padding: 0 1em;
        gap: 3px;
        color: $fs5-color11;
        cursor: pointer;
        background: #fff;
        border-radius: 0.7em;
        border: 1px solid $fs5-color11;
        display: flex;
        justify-content: center;
        cursor: pointer;
        align-items: center;
        input{
            border: none;
            background: transparent;
            width: 90%;
            text-align: center;
            cursor: pointer;
            outline: none;
            font-size: .9em;
            color: $fs5-color5;
        }
        .btn-copy{
            width: 9%;
            border: none;
            outline: none;
            background: transparent;
            svg{
                color: $fs5-color35;
                animation-name: svgSuccess;
                animation-duration: 1s;
            }
        }
    }
    @media screen and (min-width: 2040px) {
        .w100{
            width: 70%;
        }
    }
    @media only screen and (max-width: 430px) {
        img,svg{
            display: none;
        }
    }
    @keyframes svgSuccess {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }

    builderall-icon {
        --builderall-icon-size: 20px;
    }

    .tooltip-fix[ba-tooltip-title]:hover:after {
      margin-top: 40px;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/input_copy/index.vue